import queryString from 'qs';

import { apiClient } from '@/libs/http-client';

import createTaskDto from '../dto/task';
import { ITask } from '../types';
import { convertToBlob } from '../utils/convert-to-blob';

export const createTask = async ({
  image,
  batchId,
}: {
  image: string;
  batchId: string;
}): Promise<ITask> => {
  const formData = new FormData();
  formData.append('image', convertToBlob(image), 'file.jpeg');
  return apiClient()
    .put(`batches/${batchId}/tasks`, { body: formData })
    .json()
    .then((response: any) => createTaskDto(response));
};

export const updateTask = async ({
  taskId,
  batchId,
  data,
}: {
  taskId: string;
  batchId: string;
  data: any;
}): Promise<ITask> => {
  return apiClient()
    .put(`batches/${batchId}/tasks/${taskId}`, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: queryString.stringify(data),
    })
    .json();
};

export const deleteTask = async ({
  taskId,
  batchId,
}: {
  taskId: string;
  batchId: string;
}): Promise<ITask> => {
  return apiClient()
    .delete(`batches/${batchId}/tasks/${taskId}`)
    .json()
    .then((response: any) => response);
};

export const getTaskImage = async ({
  batchId,
  taskId,
  imageType,
}: {
  batchId: string;
  taskId: string;
  imageType: string;
}) => {
  const type = imageType === 'source' ? 'input_image' : 'result_image';
  return apiClient().get(`batches/${batchId}/tasks/${taskId}/${type}`).blob();
};
